import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import SelectButton from 'components/Select/SelectButton';
import colors from 'theme/colors';

const isMobile = window.innerWidth <= 845;

const DownloadMarketPresentationButton = ({ className, offLink, onLink }) => {
  const [hover, setHover] = useState(false);

  const downloadFile = (url) => {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const optionsMapping = {
    downloadOnMarketPresentation: {
      text: I18n.t('travel.onMarketPresentation'),
      action: () => downloadFile(onLink),
      disabled: !onLink
    },
    downloadOffMarketPresentation: {
      text: I18n.t('travel.offMarketPresentation'),
      action: () => downloadFile(offLink),
      disabled: !offLink
    }
  };

  const options = Object.keys(optionsMapping).map((key) => ({
    value: key,
    label: optionsMapping[key].text,
    disabled: optionsMapping[key].disabled
  }));

  const onSelectExportOption = async ({ value }) =>
    optionsMapping[value].action();

  const userAgent = navigator.userAgent.toLowerCase();
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );

  const width = 240;

  if (!onLink && !offLink) {
    return <></>;
  }

  return (
    <div
      className={className}
      onClick={
        window.innerWidth <= 845 || isTablet
          ? () => setHover(!hover)
          : undefined
      }
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <SelectButton
        placeholderIcon={!isMobile ? 'download' : null}
        placeholderLabel={I18n.t('travel.yourMarketPresentation')}
        onChange={onSelectExportOption}
        options={options}
        isMobile={window.innerWidth <= 845 || isTablet}
        customStyles={{
          menuList: {
            width: `${width}px !important`
          },
          control: {
            width: `${width}px !important`,
            backgroundColor: colors['terra-cotta']
          }
        }}
        style={{ minWidth: width }}
      />
    </div>
  );
};

export default DownloadMarketPresentationButton;
